/**
 * Estado del progreso de un Análisis Profundo a partir de los eventos que
 * agent-runtime publica por WebSocket (deep_analysis.py):
 *   planning -> plan {objective, steps} -> investigating ->
 *   query {queries, max_queries} / step_done {step_id} -> synthesizing
 * Función pura (reducer) para poder probarla sin el socket.
 */
export const initialDeepProgress = () => ({
  phase: 'planning',
  label: 'Preparando el análisis…',
  objective: '',
  steps: [],
  queries: 0,
  maxQueries: null
});

const PHASES = {
  planning: 'planning',
  plan: 'investigating',
  investigating: 'investigating',
  query: 'investigating',
  step_done: 'investigating',
  synthesizing: 'synthesizing'
};

export const reduceDeepProgress = (state, event) => {
  const current = state || initialDeepProgress();
  if (!event || !event.stage) return current;
  const next = {
    ...current,
    phase: PHASES[event.stage] || current.phase,
    label: event.label || current.label
  };
  if (event.stage === 'plan') {
    next.objective = event.objective || '';
    next.steps = (event.steps || []).map((step) => ({ id: step.id, question: step.question, done: false }));
  }
  if (event.stage === 'query') {
    next.queries = event.queries ?? current.queries;
    next.maxQueries = event.max_queries ?? current.maxQueries;
  }
  if (event.stage === 'step_done') {
    next.steps = current.steps.map((step) => (step.id === event.step_id ? { ...step, done: true } : step));
  }
  return next;
};
